import { API_BASE_URL_ENV } from "../../jsx/common/common";
import http from "../HttpService";
import BaseService from "../BaseService";

const settingsEndpoint = API_BASE_URL_ENV() + "/admin/salary/settings";
const attEndpoint =
	API_BASE_URL_ENV() + "/admin/salary/attendance-deduction-settings";

export default class SalarySettingsService extends BaseService {
	constructor() {
		super(settingsEndpoint);
	}

	getSettings() {
		return http.get(settingsEndpoint);
	}

	updateSettings(data) {
		return http.put(settingsEndpoint, data);
	}

	getAttendanceDeductionSettings() {
		return http.get(attEndpoint);
	}

	updateAttendanceDeductionSettings(data) {
		return http.put(attEndpoint, data);
	}
}
